module.exports = __webpack_public_path__ + "img/bs_silo_0.0001cfc2.png";